// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-09T10:51:46.337Z",
  gitInfo: {
    dirty: false,
    raw: "d6183afb9",
    hash: "d6183afb9",
    distance: null,
    tag: null,
    semver: null,
    suffix: "d6183afb9",
    semverString: null
  }
};
/* tslint:enable */
